import { PriceType } from '@api/generated/search-service';

/** Zkratky typu položky - musí odpovídat enumu PriceTypeCode v portal-entities. */
export const PRICE_TYPE_CODES = ['GC', 'NC', 'AC', 'NP', 'VP', 'DL'] as const;

export type PriceTypeCode = (typeof PRICE_TYPE_CODES)[number];

/**
 * Fallback odvození kódu pro endpointy, které priceTypeCode zatím neposílají.
 * Zdrojem pravdy je BE (PriceTypeCode.of) - jakmile pole dorazí do generovaného
 * klienta, preferuje se hodnota ze serveru.
 */
export const resolvePriceTypeCode = (priceType?: PriceType | string | null, isGaranted?: boolean, isCustomProduct?: boolean): PriceTypeCode | null => {
  if (isCustomProduct) return 'VP';
  switch (priceType) {
    case 'ACTION_PRICE':
      return 'AC';
    case 'SUBSTITUTE_PRICE':
      return 'NP';
    case 'FROM_DL_PRICE':
      return 'DL';
    case 'STANDARD':
      return isGaranted ? 'GC' : 'NC';
    default:
      return null;
  }
};
